import { Flex, FlexProps, HtmlContainerTag } from "./flex";

type InlineProps<T extends HtmlContainerTag = "div"> = FlexProps<T> & {
  direction?: never;
  reverse?: boolean;
  spread?: boolean;
};

export const Inline = <T extends HtmlContainerTag = "div">({ reverse, spread, ...props }: InlineProps<T>) => (
  <Flex
    direction={reverse ? "row-reverse" : "row"}
    justifyContent={spread ? "space-between" : undefined}
    {...props}
  />
);
